export default [
  {
    title: 'Dashboard',
    key: 'dashboardAlpha',
    url: '/dashboard/alpha',
    icon: 'icmn icmn-stack',
  },
  {
    divider: true,
  },
  {
    title: 'Condidats Page',
    key: 'condidats',
    url: '/condidats',
    icon: 'icmn icmn-books',
  },
  {
    title: 'Offers Page',
    key: 'offers',
    url: '/offers',
    icon: 'icmn icmn-books',
  },
  {
    divider: true,
  },
  {
    title: 'Add Profile',
    key: 'addprofile',
  },
  {
    title: 'Add Offer',
    key: 'addoffers',
  },

]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js